import { createContext } from 'react';
import type { CurrentCaseContextValue } from './CurrentCaseProvider';

export const CurrentCaseContext = createContext<CurrentCaseContextValue | undefined>(undefined);
